<template>
  <v-flex class="pl-2 pr-2">
    <v-layout align-start justify-start row class="ml-3 mb-4">
      <v-icon color="primary" style="font-size: 50px;">show_chart</v-icon>
      <h2
        :style="`color: ${$vuetify.theme.primary}`"
        class="mt-2 ml-2"
      >{{$translate('STATISTICS_OF_USERS')}}</h2>
    </v-layout>
    <v-layout row wrap justify-space-around>
      <v-flex xs3>
        <v-combobox
          v-model="dateSelected"
          :items="dateOptions"
          :label="$translate('STATISTICS_SELECT_THE_DATES')"
          outline
          return-masked-value
          persistent-hint
          @input="setDate"
        ></v-combobox>
        <v-date-picker
          v-if="!disableDatePicker"
          v-model="datesInPicker"
          @input="setDateForPicker"
          scrollable
          multiple
          no-title
        />
      </v-flex>
      <v-flex v-if="isAccountAdmin" xs3>
        <v-select
          v-model="partnerSelected"
          :items="partnerOptions"
          item-text="PartnerName"
          item-value="PartnerId"
          :label="$translate('STATISTICS_SELECT_THE_PARTNER')"
          outline
          return-object
        ></v-select>
      </v-flex>
      <v-flex xs2>
        <v-btn
          color="primary darken-1"
          :loading="disableBtn"
          round
          @click="getStatisticsOfUsers"
        >{{$translate('GET_STATISTICS')}}</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row justify-center>
      <v-flex xs8>
        <canvas id="users-chart" devicePixelRatio="10"></canvas>
      </v-flex>
    </v-layout>
    <v-layout row justify-center>
      <v-flex xs8>
        <canvas id="totalUsers-chart" devicePixelRatio="10"></canvas>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import * as dssRequest from "@/api/dssRequest";
import appConfig from "../../../config/app_config";
import BaseObject from "@/objects/BaseObject";
import _ from "lodash";
import { mapGetters } from "vuex";
import Chart from "chart.js";
import "chartjs-plugin-zoom";

export default {
  name: "Statistics_Users",
  components: {},
  computed: mapGetters({
    currentAccountId: "getCurrentAccountId"
  }),
  props: ['partnerOptions', 'isAccountAdmin', 'timeSteps'],
  data() {
    return {
      partnerSelected: {},
      dateSelected: '',
      dateOptions: [
        'Last 7 days',
        'Last 14 days',
        'Last 30 days',
        'Choose date'
      ],
      startDate: '',
      endDate: '',
      datesInPicker: [],
      disableDatePicker: true,
      nrOfPoints: 1,
      disableBtn: false,
      userStatics: {},
      ctx: {},
      userGraph: null,
      totalUsersGraph: null,
      graphsData: {
        type: "line",
        data: {
            labels: [],
            datasets: [
                {
                    label: "Nr of registered users",
                    data: [],
                    borderColor: 'rgb(255, 0, 0)',
                    borderWidth: 3,
                    cubicInterpolationMode: 'monotone'
                },
                {
                    label: "Nr of activated users",
                    data: [],
                    borderColor: 'rgb(0, 255, 0)',
                    borderWidth: 3,
                    cubicInterpolationMode: 'monotone'
                }
            ],
        },
        options: {
          responsive: true,
          title: {
            display: true,
            text: "Statistics of Users",
            fontSize: 20
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  fontSize: 9
                },
                display: true
              }
            ],
            yAxes: [
              {
                ticks: {
                  callback: function(value, index, values){
                      return value;
                  },
                  display: true,
                  beginAtZero: true,
                  stepSize: 100
                }
              }
            ]
          },
          plugins: {
            zoom: {
              pan: {
                enabled: true,
                mode: 'x'
              },
              zoom: {
                enabled: true,
                mode: 'x',
              }
            }
          }
        }
      },
      totalUsersGraphData: {
        type: "line",
        data: {
            labels: [],
            datasets: [
                {
                    label: "Nr of registered users in total",
                    data: [],
                    borderColor: 'rgb(255, 0, 0)',
                    borderWidth: 3,
                    cubicInterpolationMode: 'monotone'
                },
                {
                    label: "Nr of activated users in total",
                    data: [],
                    borderColor: 'rgb(0, 255, 0)',
                    borderWidth: 3,
                    cubicInterpolationMode: 'monotone'
                }
            ],
        },
        options: {
          responsive: true,
          title: {
            display: true,
            text: "Statistics of Users In Total",
            fontSize: 20
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  fontSize: 9
                },
                display: true
              }
            ],
            yAxes: [
              {
                ticks: {
                  callback: function(value, index, values){
                      return value;
                  },
                  display: true,
                  beginAtZero: true,
                  stepSize: 100
                }
              }
            ]
          },
          plugins: {
            zoom: {
              pan: {
                enabled: true,
                mode: 'x'
              },
              zoom: {
                enabled: true,
                mode: 'x',
              }
            }
          }
        }
      }
    };
  },

  mounted() {
    this.dateSelected = this.dateOptions[0];
    this.partnerSelected = this.partnerOptions[0];

    this.setDate();
    this.createGraphs();
    this.getStatisticsOfUsers();
  },

  methods: {
    getLabels() {
      if(this.startDate === this.endDate) {
        // Divide the day into different sections with timeSteps
        this.nrOfPoints = this.timeSteps;
        for(let i = 0; i < this.nrOfPoints; i++) {
          this.graphsData.data.labels.push(i.toString());
          this.totalUsersGraphData.data.labels.push(i.toString());
        }
      } else {
        // Use date as the x-axis
        const [dayStart, monthStart, yearStart] = this.startDate.split('-');
        const [dayEnd, monthEnd, yearEnd] = this.endDate.split('-');
        let tmpStartDate = new Date(yearStart, monthStart - 1, dayStart);
        let tmpEndDate = new Date(yearEnd, monthEnd - 1, dayEnd);
        this.nrOfPoints = Math.round((tmpEndDate.getTime() - tmpStartDate.getTime()) / 86400000 + 1);

        let tmpDate = new Date();
        let tmpDateFormatted = '';

        for(let i = 0; i < this.nrOfPoints; i++) {
          tmpDate.setTime(tmpStartDate.getTime() + i * 86400000);
          tmpDateFormatted = ('0' + tmpDate.getDate()).slice(-2) + '-' +
                            ('0' + (tmpDate.getMonth() + 1)).slice(-2) + '-' + tmpDate.getFullYear();
          this.graphsData.data.labels.push(tmpDateFormatted);
          this.totalUsersGraphData.data.labels.push(tmpDateFormatted);
        }
      }
    },

    translateLabels() {
      // When start date equals to end date, the label should be translated to time sections
      this.graphsData.data.labels = [];
      this.totalUsersGraphData.data.labels = [];
      let newLabel = '';
      let timeLength = 24 / this.nrOfPoints;
      for(let i = 0; i < this.nrOfPoints; i++) {
        newLabel = `${i * timeLength} - ${(i+1) * timeLength} Hours`;
        console.log("New label ", i, newLabel);
        this.graphsData.data.labels.push(newLabel);
        this.totalUsersGraphData.data.labels.push(newLabel);
      }
    },

    setDate() {
      if(this.dateSelected === this.dateOptions[3]) {
        this.startDate = '';
        this.endDate = '';
        this.datesInPicker = [];
        this.disableDatePicker = false;
        this.dateSelected = 'Choose start and end dates';
      } else {
        let tmpDate = new Date();
        this.endDate = ('0' + tmpDate.getDate()).slice(-2) + '-' +
                         ('0' + (tmpDate.getMonth() + 1)).slice(-2) + '-' + tmpDate.getFullYear();
        if(this.dateSelected === this.dateOptions[0])      this.nrOfPoints = 7;
        else if(this.dateSelected === this.dateOptions[1]) this.nrOfPoints = 14;
        else if(this.dateSelected === this.dateOptions[2]) this.nrOfPoints = 30;

        this.startDate = this.getStartDate(this.endDate, this.nrOfPoints);
      }
    },

    getStartDate(endDate, nrOfPoints) {
      // Format of date: dd-mm-yyyy
      const [dayEnd, monthEnd, yearEnd] = endDate.split('-');
      let tmpDate = new Date(yearEnd, monthEnd - 1, dayEnd);
      tmpDate.setTime(tmpDate.getTime() - ((nrOfPoints - 1) * 86400000));
      return ('0' + tmpDate.getDate()).slice(-2) + '-' +
             ('0' + (tmpDate.getMonth() + 1)).slice(-2) + '-' + tmpDate.getFullYear();
    },

    setDateForPicker() {
      if(this.datesInPicker.length == 0)
      {
        if(this.startDate === "")
        {
          this.dateSelected = '-';
          return;
        }
        else
        {
          this.endDate = this.startDate;
          this.dateSelected = this.startDate + ' - ' + this.endDate;

          // Close the date picker
          this.disableDatePicker = true;
        }
      }
      else if(this.datesInPicker.length == 1)
      {
        // Get start date
        const [yearStart, monthStart, dayStart] = this.datesInPicker[0].split('-');
        this.startDate = `${dayStart}-${monthStart}-${yearStart}`;

        this.dateSelected = this.startDate + ' - ';
      }
      else if(this.datesInPicker.length == 2)
      {
        // Get end date
        const [yearEnd, monthEnd, dayEnd] = this.datesInPicker[1].split('-');
        this.endDate = `${dayEnd}-${monthEnd}-${yearEnd}`;

        this.dateSelected = this.startDate + ' - ' + this.endDate;

        // Close the date picker
        this.disableDatePicker = true;
      }
      else
      {
        // Close the date picker
        this.disableDatePicker = true;
      }
    },

    createGraphs() {
      // Update labels of the graph
      this.graphsData.data.labels = [];
      this.totalUsersGraphData.data.labels = [];
      this.getLabels();

      // Initialize each data in data sets with 0
      this.graphsData.data.datasets.forEach(element => {
        element.data = Array(Math.round(this.nrOfPoints)).fill(0);
      });

      this.totalUsersGraphData.data.datasets.forEach(element => {
        element.data = Array(Math.round(this.nrOfPoints)).fill(0);
      });

      if(this.startDate == this.endDate) this.translateLabels();

      if(this.userGraph) this.userGraph.destroy();
      this.ctx = document.getElementById('users-chart');
      this.userGraph = new Chart(this.ctx, this.graphsData);

      if(this.totalUsersGraph) this.totalUsersGraph.destroy();
      this.ctx = document.getElementById('totalUsers-chart');
      this.totalUsersGraph = new Chart(this.ctx, this.totalUsersGraphData);
    },

    updateGraphs() {
      // Update labels of the graph
      this.graphsData.data.labels = [];
      this.totalUsersGraphData.data.labels = [];
      this.getLabels();

      // Initialize each data in data sets with 0
      this.graphsData.data.datasets.forEach(element => {
        element.data = Array(Math.round(this.nrOfPoints)).fill(0);
      });

      this.totalUsersGraphData.data.datasets.forEach(element => {
        element.data = Array(Math.round(this.nrOfPoints)).fill(0);
      });

      // Update registered user data
      for (let [k, v] of Object.entries(this.userStatics.Registered)) {
        let itemIndex = this.graphsData.data.labels.indexOf(k);
        if(itemIndex !== -1) {
          // Get the corresponding index of the date in the array of labels
          this.graphsData.data.datasets[0].data[itemIndex] = Number(v);
          this.totalUsersGraphData.data.datasets[0].data[itemIndex] = Number(this.userStatics.TotalRegisteredBase) + Number(v);
        }
      }

      // Update activated user data
      for (let [k, v] of Object.entries(this.userStatics.Activated)) {
        let itemIndex = this.graphsData.data.labels.indexOf(k);
        if(itemIndex !== -1) {
          // Get the corresponding index of the date in the array of labels
          this.graphsData.data.datasets[1].data[itemIndex] = Number(v);
        }
      }

      // Update total registered users data
      let totalRegisteredBase = Number(this.userStatics.TotalRegisteredBase);
      for(let i = 0; i < this.graphsData.data.datasets[0].data.length; i++)
      {
        let nrOfRegistered = this.graphsData.data.datasets[0].data[i];
        if(i == 0)
          this.totalUsersGraphData.data.datasets[0].data[i] = nrOfRegistered + totalRegisteredBase;
        else
        {
          let totalNrPrev = this.totalUsersGraphData.data.datasets[0].data[i - 1];
          this.totalUsersGraphData.data.datasets[0].data[i] = nrOfRegistered + totalNrPrev;
        }
      }

      // Update total activated users data
      let totalActivatedBase = Number(this.userStatics.TotalActivatedBase);
      for(let i = 0; i < this.graphsData.data.datasets[1].data.length; i++)
      {
        let nrOfActivated = this.graphsData.data.datasets[1].data[i];
        if(i == 0)
          this.totalUsersGraphData.data.datasets[1].data[i] = nrOfActivated + totalActivatedBase;
        else
        {
          let totalNrPrev = this.totalUsersGraphData.data.datasets[1].data[i - 1];
          this.totalUsersGraphData.data.datasets[1].data[i] = nrOfActivated + totalNrPrev;
        }
      }

      if(this.startDate == this.endDate) this.translateLabels();

      this.userGraph.update();
      this.totalUsersGraph.update();
    },

    getStatisticsOfUsers() {
      // Disable the button until the request is done
      this.disableBtn = true;

      // Create the payload
      const payload = {
        StartDate:  this.startDate,
        EndDate:    this.endDate,
        FunctionId: "EventFunctionLibrary::getUserStats"
      };

      if(this.partnerSelected.PartnerId > 0) payload.PartnerId = this.partnerSelected.PartnerId;
      if(this.startDate === this.endDate)    payload.TimeSteps = this.timeSteps;

      // Send the request and process the response
      dssRequest.doRequest(
        response => {
          console.log("the call for getUserStats was successful", response);
          this.userStatics = Object.assign({}, response.data.Users);
          this.updateGraphs();
          this.disableBtn = false;
        },
        error => {
          console.log("the call for getUserStats was not successful", error);
          this.disableBtn = false;
        },
        "communicateWithDBLibrary",
        this.currentAccountId,
        payload
      );
    }
  }
};
</script>

<style lang="scss", scoped>
.center_table > td {
  text-align: center;
}
</style>
